import React from "react";

import logo from "shared/assets/logo_big.png";

import { Card, Logo, Subtitle } from "./styles";

interface AuthCardProps {
    subtitle: string;
    children: React.ReactNode;
}

/*
* Рамка экранов входа и регистрации: логотип, подпись и карточка. Общая двум фичам, поэтому
* лежит в features/Auth — в кит не годится, это не примитив, а страница конкретного раздела.
* */
export const AuthCard = ({ subtitle, children }: AuthCardProps) => (
    <Card>
        <Logo src={logo} alt="restify" />
        <Subtitle>{subtitle}</Subtitle>
        {children}
    </Card>
);
